import { render, staticRenderFns } from "./CatList.vue?vue&type=template&id=64799f7c&scoped=true"
import script from "./CatList.vue?vue&type=script&lang=js"
export * from "./CatList.vue?vue&type=script&lang=js"
import style0 from "./CatList.vue?vue&type=style&index=0&id=64799f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64799f7c",
  null
  
)

export default component.exports